<template>
    <v-container>
        <vueHeadful
        :title="this.$i18n.t('Menu.ProductosOficina') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12" name="dialog" align="center">
                <v-btn style="min-width:20%;" x-large color="primary" @click="abrirDialog({tipo: 'nuevo'})">{{ $t('Formularios.NuevoProducto') }}</v-btn>
                <DialogProducto :productoEditar="productoEditar" @onResult="actualizarListaProductos"/>
                <v-col cols="12" name="productos">
                    <v-data-iterator :items="productos">
                        <template v-slot:default="props">
                          <v-container class="pa-0">
                            <v-row>
                            <v-col cols="12" xs="12" sm="6" md="4" v-for="(i, index) in props.items" :key="i.uid">
                                <v-card>
                                <v-card-title>
                                    <v-row style="max-width:-webkit-fill-available!important;">
                                    <v-col cols="12" align="center">
                                        <h3>{{i.titulo}}</h3>
                                        <h5 class="font-weight-light">{{ $t('Categoria.'+i.subcategoria) }}</h5>
                                        <h4>{{ i.meGusta }} <v-icon size="20" color="red" class="mb-1">far fa-heart</v-icon></h4>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-img :src="i.imagenPrincipal" contain />
                                    </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-text>
                                    <v-row style="max-width:-webkit-fill-available!important;">
                                    <v-col v-if="i.exponer" cols="12" xs="12" md="12" align="center">
                                      <span style="font-size:15px;" class="font-weight-bold">{{ $t('Formularios.Exhibicion').toUpperCase() }}</span>
                                    </v-col>
                                    <v-col cols="12" xs="12" :md="i.fisico ? '6' : '12'" align="center" v-if="i.digital">
                                      <h3>{{$t('Formularios.Digital')}}</h3>
                                      <h5>{{i.precioPago}}</h5>
                                      <h5 v-if="i.ilimitado">{{ $t('Busqueda.UnidadesIlimitadas')}}</h5>
                                      <h5 v-else>{{i.cantidadDigital}} {{ $t('Busqueda.UnidadesDisponibles')}}</h5>
                                      <h5>{{i.digitalesVendidos}} {{ $t('Busqueda.Vendidos')}}</h5>
                                    </v-col>
                                    <v-col cols="12" xs="12" :md="i.digital ? '6' : '12'" v-if="i.fisico">
                                      <h3>{{$t('Formularios.Fisico')}}</h3>
                                      <h5>{{i.precioPagoDig}}</h5>
                                      <h5 v-if="!i.exponer">{{i.cantidadFisico}} {{ $t('Busqueda.UnidadesDisponibles')}}</h5>
                                      <h5>{{i.fisicosVendidos}} {{ $t('Busqueda.Vendidos')}}</h5>
                                    </v-col>
                                    </v-row>
                                    <v-row>
                                    <v-col cols="3" v-for="(n, index) in i.imagenes" :key="index">
                                        <v-img :src="n" contain/>
                                    </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="6">
                                        <v-btn outlined block @click="abrirDialogEliminar(i.uid, index)">{{$t('Formularios.Eliminar')}}</v-btn>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="6">
                                        <v-btn color="primary" outlined block @click="abrirDialog({ tipo: 'editar', productoEditar: i})">{{$t('Formularios.Editar')}}</v-btn>
                                    </v-col>
                                    </v-row>
                                </v-card-actions>
                                </v-card>
                            </v-col>
                            </v-row>
                          </v-container>
                        </template>
                    </v-data-iterator>
                </v-col>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogEliminar" width="60%">
          <v-card>
            <v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" align="center">
                    <h2>{{$t('Alerta.EliminarProducto')}}</h2>
                    <br>
                    <v-btn class="mx-3" color="primary" large @click="dialogEliminar = false">{{$t('Formularios.Salir')}}</v-btn>
                    <v-btn class="mx-3" color="red white--text" large @click="eliminar()">{{$t('Carrito.Continuar')}}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import firebase from '@/plugins/firebase'
import DialogProducto from '../../components/DialogProducto'
export default {
  name: 'ProductosOficina',
  components: {
    DialogProducto
  },
  data () {
    return {
      productoEditar: null,
      productos: [],
      dialogEliminar: false,
      uidEliminar: null,
      indexEliminar: null
    }
  },
  computed: {
    ...mapGetters(['getUsuario', 'getIdioma'])
  },
  methods: {
    ...mapMutations(['setDialogMontaje', 'setTipoMontaje', 'setAlerta', 'setTextoAlerta']),
    abrirDialog (info) {
      if (info.tipo === 'editar') {
        this.productoEditar = info.productoEditar
      }
      this.setTipoMontaje(info.tipo)
      this.setDialogMontaje(true)
    },
    abrirDialogEliminar (uid, index) {
      this.uidEliminar = uid
      this.indexEliminar = index
      this.dialogEliminar = true
    },
    eliminar () {
      firebase.firestore().collection('productos').doc(this.uidEliminar).delete()
      this.productos.splice(this.indexEliminar, 1)
      this.setAlerta()
      this.setTextoAlerta('Alerta.ProductoEliminado')
      this.dialogEliminar = false
      this.uidEliminar = null
      this.indexEliminar = null
    },
    actualizarListaProductos () {
      // console.log('Actualización de productos')
      this.productos = []
      firebase.firestore().collection('productos').where('artista.uid', '==', this.getUsuario.uid).get().then(info => {
        for (let i = 0; i < info.docs.length; i++) {
          this.productos.push(info.docs[i].data())
        }
      })
    }
  },
  mounted () {
    // ACTUALIZAR PRECIO DOLAR DIARIAMENTE
    axios({
      method: 'get',
      url: 'http://www.floatrates.com/daily/usd.json',
      crossDomain: true
    })
      .then(response => {
        firebase.firestore().collection('utilidades').doc('monetario').update({ dolar: response.data.cop.rate.toFixed() })
        // return res.send(response.data.result.value.toFixed())
        // return console.log(response.data.cop.rate.toFixed())
      })
      .catch(error => {
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    this.actualizarListaProductos()
  }
}
</script>
